import Layout from "@/layout/index.vue"; // 主布局组件
export const constantRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/pages/login/index.vue"),
    meta: { title: "登录" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("@/pages/404/index.vue"),
    meta: { title: "404" },
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      // ====================== 1. 首页模块 ======================
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/pages/dashboard/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "vocabulary", // 路由路径，访问时为 /dashboard/statistics
        name: "Vocabulary",
        component: () => import("@/pages/vocabulary/index.vue"), // 假设的子页面组件路径
        meta: {
          title: "词汇测试", // 子菜单标题
        },
      },
      {
        path: "forgetting", // 路由路径，访问时为 /dashboard/statistics
        name: "Forgetting",
        component: () => import("@/pages/forgetting/index.vue"), // 假设的子页面组件路径
        meta: {
          title: "抗遗忘", // 子菜单标题
        },
      },
      {
        path: "review", // 路由路径，访问时为 /dashboard/statistics
        name: "Review",
        component: () => import("@/pages/forgetting/review.vue"), // 假设的子页面组件路径
        meta: {
          title: "抗遗忘复习", // 子菜单标题
        },
      },
      {
        path: "mistakeNotebook", // 路由路径，访问时为 /dashboard/statistics
        name: "MistakeNotebook",
        component: () => import("@/pages/mistakeNotebook/index.vue"), // 假设的子页面组件路径
        meta: {
          title: "错题本", // 子菜单标题
        },
      },
      {
        path: "lessonPreparation", // 路由路径，访问时为 /dashboard/statistics
        name: "LessonPreparation",
        component: () => import("@/pages/lessonPreparation/index.vue"), // 假设的子页面组件路径
        meta: {
          title: "上课", // 子菜单标题
        },
      },
      {
        path: "workingHours", // 路由路径，访问时为 /dashboard/statistics
        name: "WorkingHours",
        component: () => import("@/pages/workingHours/index.vue"), // 假设的子页面组件路径
        meta: {
          title: "工作时间管理", // 子菜单标题
        },
      },
      {
        path: "learn-train", // 路由路径，访问时为 /learn-train
        name: "LearnTrain",
        component: () => import("@/pages/learn-train/index.vue"),
        meta: {
          title: "学练一体", // 子菜单标题
        },
      },
      {
        path: "deepLearning", // 路由路径，访问时为 /dashboard/statistics
        name: "DeepLearning",
        component: () => import("@/pages/deepLearning/index.vue"), // 假设的子页面组件路径
        meta: {
          title: "深度学习", // 子菜单标题
        },
      },
      {
        path: "evaluation", // 路由路径，访问时为 /dashboard/statistics
        name: "Evaluation",
        component: () => import("@/pages/evaluation/index.vue"), // 假设的子页面组件路径
        meta: {
          title: "本书测评", // 子菜单标题
        },
      },
      // {
      //   path: "preschoolMonitoring", // 路由路径，访问时为 /dashboard/statistics
      //   name: "PreschoolMonitoring",
      //   component: () => import("@/pages/preschoolMonitoring/index.vue"), // 假设的子页面组件路径
      //   meta: {
      //     title: "学前监测", // 子菜单标题
      //   },
      // },
      // ====================== 2. 销课中心模块 ======================
      {
        path: "course-sales",
        name: "CourseSales",
        component: () => import("@/pages/course-sales/index.vue"),
        meta: {
          title: "销课中心",
        },
      },
      {
        path: "readPage",
        name: "ReadPage",
        component: () => import("@/pages/readPage/index.vue"),
        meta: {
          title: "阅读器",
        },
      },
      // 销课中心子页面（如订单列表）
      //   {
      //     path: "course-sales/order-list",
      //     name: "OrderList",
      //     component: () => import("@/pages/course-sales/order-list/index.vue"),
      //     meta: {
      //       title: "订单列表",
      //       icon: "Document", // 子菜单图标
      //     },
      //   },

      // ====================== 3. 用户信息模块 ======================
      {
        path: "user-info",
        name: "UserInfo",
        component: () => import("@/pages/user-info/index.vue"),
        meta: {
          title: "用户信息",
        },
      },

      // ====================== 4. 个人中心模块 ======================
      {
        path: "profile",
        name: "Profile",
        component: () => import("@/pages/profile/index.vue"),
        meta: {
          title: "个人中心",
        },
      },
      {
        path: "words",
        name: "Words",
        component: () => import("@/components/learn-train/words.vue"),
        meta: {
          title: "单词",
        },
      },
      {
        path: "reading",
        name: "ReadPage",
        component: () => import("@/components/learn-train/ReadingList.vue"),
        meta: {
          title: "阅读",
        },
      },
      {
        path: "reading-articles",
        name: "ReadingArticles",
        component: () => import("@/components/learn-train/ReadingArticles.vue"),
        meta: {
          title: "选择文章",
        },
      },
      {
        path: "reading-content",
        name: "ReadingContent",
        component: () => import("@/components/learn-train/ReadingContent.vue"),
        meta: {
          title: "阅读内容",
        },
      },
      {
        path: "translation",
        name: "Translation",
        component: () => import("@/components/learn-train/Translation.vue"),
        meta: {
          title: "翻译",
        },
      },
      {
        path: "grammar",
        name: "Grammar",
        component: () => import("@/components/learn-train/Grammar.vue"),
        meta: {
          title: "语法",
        },
      },
      {
        path: "testRecord",
        name: "TestRecord",
        component: () => import("@/pages/testRecord/index.vue"),
        meta: {
          title: "测试记录",
        },
      },
    ],
  },
  // 匹配所有未定义路由，跳转404
  { path: "/:pathMatch(.*)*", redirect: "/404", meta: { hidden: true } },
];

// 业务路由（需权限控制）
export const asyncRoutes = [];
